/**
 * @file
 * Sidebar collapse toggle. State persists in localStorage so the user's
 * preference survives page navigations.
 */
const KEY = 'eudat:sidebar-collapsed';

Drupal.behaviors.eudatSidebar = {
  attach(context) {
    const layout = context.querySelector?.('[data-eudat-layout]');
    if (!layout || layout.dataset.eudatSidebarInit === '1') {
      return;
    }
    layout.dataset.eudatSidebarInit = '1';

    // The desktop "collapse to a 72px rail" state is meaningless on mobile
    // (its toggle is hidden and the sidebar is a full-width drawer). Apply the
    // persisted preference only on desktop; strip it on mobile so labels show.
    const mobile = window.matchMedia('(max-width: 768px)');

    // The group switcher moves to the drawer on mobile.
    const groupSwitcher = layout.querySelector('.eudat-group-switcher');
    const switcherSlot = layout.querySelector('[data-eudat-switcher-slot]');
    const switcherHome = groupSwitcher ? groupSwitcher.parentNode : null;

    const relocate = (toMobile) => {
      if (groupSwitcher && switcherSlot && switcherHome) {
        (toMobile ? switcherSlot : switcherHome).appendChild(groupSwitcher);
        switcherSlot.hidden = !toMobile;
      }
    };

    // Mobile overlay drawer: a burger in the topbar opens the <wa-drawer>.
    const burger = layout.querySelector('[data-eudat-sidebar-open]');
    const mobileDrawer = document.getElementById('eudat-mobile-drawer');

    const setOpen = (open) => {
      if (mobileDrawer) {
        const method = open ? 'show' : 'hide';
        if (typeof mobileDrawer[method] === 'function') {
          mobileDrawer[method]();
        } else {
          mobileDrawer.open = open;
        }
      }
      burger?.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    const toggle = layout.querySelector('[data-eudat-sidebar-toggle]');
    const toggleIcon = toggle?.querySelector('wa-icon');

    // The icon's label is the toggle's accessible name; keep it describing
    // the action the next click performs.
    const setCollapsed = (collapsed) => {
      layout.classList.toggle('is-sidebar-collapsed', collapsed);
      toggleIcon?.setAttribute('label', collapsed ? toggleIcon.dataset.labelCollapsed : toggleIcon.dataset.labelExpanded);
    };

    const syncViewport = () => {
      if (mobile.matches) {
        setCollapsed(false);
      } else {
        setCollapsed(localStorage.getItem(KEY) === '1');
        setOpen(false); // drawer state is mobile-only
      }
      relocate(mobile.matches);
    };

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    toggle?.addEventListener('click', () => {
      const collapsed = !layout.classList.contains('is-sidebar-collapsed');
      localStorage.setItem(KEY, collapsed ? '1' : '0');

      if (!document.startViewTransition || reducedMotion.matches) {
        setCollapsed(collapsed);
        return;
      }
      // The attribute scopes the view-transition names (see _layout.scss).
      const root = document.documentElement;
      root.dataset.eudatSidebarVt = '';
      document.startViewTransition(() => setCollapsed(collapsed))
        .finished.finally(() => delete root.dataset.eudatSidebarVt);
    });

    burger?.addEventListener('click', () => setOpen(true));

    mobile.addEventListener('change', syncViewport);
    syncViewport();
  },
};

/**
 * Drops a shadow under the top bar once the page is scrolled.
 */
Drupal.behaviors.eudatTopbarShadow = {
  attach(context) {
    const topbar = context.querySelector?.('.eudat-topbar');
    if (!topbar || topbar.dataset.eudatShadowInit === '1') {
      return;
    }
    topbar.dataset.eudatShadowInit = '1';

    // <wa-page> scrolls the window, not an inner element.
    const sync = () => topbar.classList.toggle('is-scrolled', window.scrollY > 0);
    window.addEventListener('scroll', sync, { passive: true });
    sync();
  },
};
